export default __webpack_public_path__ + "static/media/stop_hover.e0b6bf27.svg";